"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reinforcedAuthReducer = void 0;
const api_rest_1 = require("@sparkasse/api-rest");
const __1 = require("..");
const reinforcedAuth_types_1 = require("./reinforcedAuth.types");
const initialState = {
    authToken: (0, api_rest_1.SumsubAccessTokenDtoFromJSON)({}),
    salvataggioRiconoscimentoCompletato: false,
    campagnaRiconoscimentoEffettuata: undefined,
    checkRiconscimentoRafforzatoAbilitatoDispositiva: (0, api_rest_1.ReinforcedCampaignResponseDtoFromJSON)({}),
    statoCampagnaRiconoscimento: undefined,
    spidButton: (0, api_rest_1.ButtonDtoFromJSON)({}),
    spidLink: (0, api_rest_1.SpidCieResponseUrlDtoFromJSON)({}),
    cieButton: (0, api_rest_1.ButtonDtoFromJSON)({}),
    cieLink: (0, api_rest_1.SpidCieResponseUrlDtoFromJSON)({}),
    sumsubSdkOpened: false
};
const reinforcedAuthReducer = (state = initialState, action) => {
    switch (action.type) {
        case reinforcedAuth_types_1.EReinforcedAuthActionTypes.REINFORCED_AUTH_GET_AUTH_TOKEN_SUCCESS:
            return {
                ...state,
                authToken: action.payload
            };
        case reinforcedAuth_types_1.EReinforcedAuthActionTypes.REINFORCED_AUTH_RESET_AUTH_TOKEN:
            return {
                ...state,
                authToken: initialState.authToken
            };
        case reinforcedAuth_types_1.EReinforcedAuthActionTypes.REINFORCED_AUTH_CHECK_RECUPERA_STATO_CAMPAGNA_RICONSCIMENTO_SUCCESS:
            return {
                ...state,
                statoCampagnaRiconoscimento: action.payload
            };
        case reinforcedAuth_types_1.EReinforcedAuthActionTypes.REINFORCED_AUTH_RESET_STATO_CAMPAGNA_RICONOSCIMENTO:
            return {
                ...state,
                statoCampagnaRiconoscimento: initialState.statoCampagnaRiconoscimento
            };
        case reinforcedAuth_types_1.EReinforcedAuthActionTypes.REINFORCED_AUTH_CHECK_RICONOSCIMENTO_RAFFORZATO_ATTIVO_DISPOSITIVA_SUCCESS:
            return {
                ...state,
                checkRiconscimentoRafforzatoAbilitatoDispositiva: action.payload
            };
        case reinforcedAuth_types_1.EReinforcedAuthActionTypes.REINFORCED_AUTH_SALVA_COMPLETAMENTO_CAMPAGNA_RICONOSCIMENTO_SUCCESS:
            return {
                ...state,
                salvataggioRiconoscimentoCompletato: action.payload.response
            };
        case reinforcedAuth_types_1.EReinforcedAuthActionTypes.REINFORCED_AUTH_RESET_COMPLETAMENTO_CAMPAGNA_RICONOSCIMENTO:
            return {
                ...state,
                salvataggioRiconoscimentoCompletato: initialState.salvataggioRiconoscimentoCompletato
            };
        case reinforcedAuth_types_1.EReinforcedAuthActionTypes.REINFORCED_AUTH_VERIFICA_CAMPAGNA_RICONOSCIMENTO_EFFETTUATA_SUCCESS:
            return {
                ...state,
                campagnaRiconoscimentoEffettuata: action.payload.response
            };
        case reinforcedAuth_types_1.EReinforcedAuthActionTypes.REINFORCED_AUTH_GET_SPID_BUTTON_SUCCESS:
            return {
                ...state,
                spidButton: action.payload
            };
        case reinforcedAuth_types_1.EReinforcedAuthActionTypes.REINFORCED_AUTH_GET_SPID_LINK_SUCCESS:
            return {
                ...state,
                spidLink: action.payload
            };
        case reinforcedAuth_types_1.EReinforcedAuthActionTypes.REINFORCED_AUTH_GET_CIE_BUTTON_SUCCESS:
            return {
                ...state,
                cieButton: action.payload
            };
        case reinforcedAuth_types_1.EReinforcedAuthActionTypes.REINFORCED_AUTH_GET_CIE_LINK_SUCCESS:
            return {
                ...state,
                cieLink: action.payload
            };
        case reinforcedAuth_types_1.EReinforcedAuthActionTypes.REINFORCED_AUTH_RESET_CIE_SPID:
            return {
                ...state,
                spidButton: initialState.spidButton,
                spidLink: initialState.spidLink,
                cieButton: initialState.cieButton,
                cieLink: initialState.cieLink
            };
        case reinforcedAuth_types_1.EReinforcedAuthActionTypes.REINFORCED_AUTH_SET_SDK_SUMSUB_OPENED:
            return {
                ...state,
                sumsubSdkOpened: action.payload
            };
        case reinforcedAuth_types_1.EReinforcedAuthActionTypes.REINFORCED_AUTH_RESET_CHECK_RICONOSCIMENTO_RAFFORZATO_ATTIVO_DISPOSITIVA:
            return {
                ...state,
                checkRiconscimentoRafforzatoAbilitatoDispositiva: initialState.checkRiconscimentoRafforzatoAbilitatoDispositiva
            };
        case __1.EReduxActionTypes.RESET_ALL: // action invocata dalla logout
            return {
                ...initialState
            };
        default:
            return state;
    }
};
exports.reinforcedAuthReducer = reinforcedAuthReducer;
exports.default = exports.reinforcedAuthReducer;
